import moment from "moment";

import { ACTIVITY_TYPES } from "Constants/constants";
import { SUCCESS_TIMEOUT } from "Containers/Notifications/Notifications.utils";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import {
  loadDeploymentNext,
  deploymentSizingApiEnabledSelector
} from "Reducers/environment/deployment";
import { useAppDispatch } from "Store/hooks";

import type { Activity } from "@packages/client";

const ADD_DURATION = `${SUCCESS_TIMEOUT / 1000}`;

type UseReloadDeploymentProps = {
  activity: Activity;
  organizationId: string;
  projectId: string;
};
export const useReloadDeployment = ({
  activity,
  organizationId,
  projectId
}: UseReloadDeploymentProps) => {
  const dispatch = useAppDispatch();
  const isSizingApiEnabled = useSelectorWithUrlParams(
    deploymentSizingApiEnabledSelector
  );

  /**
   * Why?
   * The following activity types need to trigger a re-dispatch for deployment/next api so the configure resources page always has the updated resources. This is applicable only for projects that have "isSizingApiEnabled"
   */

  if (
    !isSizingApiEnabled ||
    activity?.type !== ACTIVITY_TYPES.ENVIRONMENT.MERGE
  ) {
    return;
  }

  const limit = moment(activity.completed_at).add(ADD_DURATION, "seconds");
  const now = moment();
  const isOld = moment(now).isAfter(limit.format());

  if (
    activity.state === "complete" &&
    activity.result === "success" &&
    activity?.type === ACTIVITY_TYPES.ENVIRONMENT.MERGE &&
    !isOld
  ) {
    const environmentId = activity?.environments?.[1];
    dispatch(
      loadDeploymentNext({
        organizationId,
        projectId,
        environmentId: environmentId
      })
    );
  }
};
